import { createFileRoute } from '@tanstack/react-router';
import { resolveFallbackRoute, useAccessContext } from '@vizit/access';
import { NoAccessScreen } from '@vizit/organisms';

export const Route = createFileRoute('/_authenticated/no-access')({
  staticData: {
    pageName: 'No Access',
  },
  component: NoAccessRoute,
});

function NoAccessRoute() {
  const { me } = useAccessContext();
  const fallbackHref = me ? resolveFallbackRoute(me) : null;

  return <NoAccessScreen fallbackHref={fallbackHref} fallbackLabel="Go to an accessible page" />;
}
